import { render, staticRenderFns } from "./ImageAttrWithDetailToTop.vue?vue&type=template&id=33af8dea&scoped=true&"
import script from "./ImageAttrWithDetailToTop.vue?vue&type=script&lang=js&"
export * from "./ImageAttrWithDetailToTop.vue?vue&type=script&lang=js&"
import style0 from "./ImageAttrWithDetailToTop.vue?vue&type=style&index=0&id=33af8dea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af8dea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default,TheBlockHeader: require('/web/components/TheBlockHeader.vue').default})
